<template>
  <div class="wrapper">
    <div class="list-wrapper">
      <list-item
        v-for="item in businessList"
        :itemData="item"
        :key="'bu'+item.id"
        @toLink="getDetail"
      ></list-item>
    </div>
    <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
  </div>
</template>
<script>
import listItem from "@/components/common/listItem.vue";
import ModelPage from "@/components/common/ModelPage";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      ariList: [],
      businessList: [],
      page: 1,
      count: 10
    };
  },
  mounted() {
    if (this.$route.query.type == 1) {
      this.firstTitle("海洋标准化");
    } else if (this.$route.query.type == 2) {
      this.firstTitle("海洋计量");
    } else if (this.$route.query.type == 3) {
      this.firstTitle("海洋质量监督");
    }
    this.workList();
  },
  computed: {
    ...mapGetters(["touchflg", "searchVuex"])
  },
  methods: {
    ...mapActions(["firstTitle", "secondTitle"]),
    getDetail(id) {
      if (this.touchflg) {
        this.$router.push({
          name: "BusinessDetail",
          query: {
            id: id
          }
        });
      }
    },
    workList() {
      const params = {
        id: this.$route.query.workinfoId
          ? this.$route.query.workinfoId
          : this.$route.query.firstId,
        page: this.page,
        count: this.count,
        search_word: this.searchVuex
      };
      userApi.workList(params).then(res => {
        this.ariList = res.data;
        this.businessList = res.data.list;
        this.secondTitle(this.ariList.workname);
        if (this.ariList.total == "1") {
          this.$router.push({
            name: "BusinessDetail",
            query: {
              firstId: this.$route.query.firstId,
              workinfoId: this.$route.query.workinfoId,
              id: this.businessList[0].id,
              type: this.$route.query.type
            }
          });
        }
      });
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getPersonList();
    }
  },
  watch: {
    $route() {
      this.workList();
    }
  },
  components: {
    listItem,
    ModelPage
  }
};
</script>

<style lang="less" scoped>
@import "./../../../common/minix.less";
.wrapper {
  .list-wrapper {
    width: 100%;
    padding: 20 / @rem;
    box-sizing: border-box;
    background: #f2f2f2;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BusinessWork/Children/introduction.vue